


































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateInformation } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constant from '@/utils/constant'

@Component({
  components: {
    VImageUpload,
  },
})
export default class CreateInformationDialog extends Vue {
  private show = false
  private constant = constant
  private data: any = {
    bannersGileList: [],
    descImgsGileList: [],
    coverImgGileList: [],
    banners: '',
    descImgs: '',
    coverImg: '',
    sort: 0,
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    title: [this.requiredRule],
  }

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {
      bannersGileList: [],
      descImgsGileList: [],
      coverImgGileList: [],
      banners: '',
      descImgs: '',
      coverImg: '',
      sort: 0,
    }
  }
  public open(param?: any) {
    this.show = true
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      this.data.banners = this.data.bannersGileList.map((e: any) => e.url).join(',')
      this.data.descImgs = this.data.descImgsGileList.map((e: any) => e.url).join(',')
      this.data.coverImg = this.data.coverImgGileList.map((e: any) => e.url).join(',')
      

      await CreateInformation(this.data)
      Message.success('保存成功')
      this.close()
    })
  }
}
